import { render, staticRenderFns } from "./OneclickwritingDilets.vue?vue&type=template&id=8a06e9d4&scoped=true&"
import script from "./OneclickwritingDilets.vue?vue&type=script&lang=js&"
export * from "./OneclickwritingDilets.vue?vue&type=script&lang=js&"
import style0 from "./OneclickwritingDilets.vue?vue&type=style&index=0&id=8a06e9d4&lang=scss&scoped=true&"
import style1 from "./OneclickwritingDilets.vue?vue&type=style&index=1&id=8a06e9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a06e9d4",
  null
  
)

export default component.exports